export default "__VITE_PUBLIC_ASSET__21ecd4b6__"